import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the deletion actions of `Application/AiCostLimits/Limits/**`. */
const AiCostLimitsNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="AI_COST_LIMIT_DELETED"
				title="Plafond supprimé"
				message="Le plafond a bien été supprimé."
			/>
			<ErrorNotification
				eventName="AI_COST_LIMIT_DELETION_FAILED"
				title="Erreur"
				message="Le plafond n'a pas pu être supprimé."
			/>
		</React.Fragment>
	);
};

export default AiCostLimitsNotifications;
